
import { mapActions, mapState } from "vuex";
import ResponsiveDialog from "./responsive-dialog.vue";
import CountrycodeWithTextfield from "../common/countrycode-with-textfield.vue";

export default {
  components: { ResponsiveDialog, CountrycodeWithTextfield },
  props: {
    dialog: false
  },
  data() {
    return {
      valid: false,
      loading: false,
      saveLoading: false,
      isPhoneValid: false,
      isContactInfoValid: false,
      contacts: [],
      selection: [],
      contactTypes: [
        { value: "whatsapp", label: "Send updates via WhatsApp" },
        { value: "sms", label: "Send updates via sms" }
        // { value: "email", label: "Send updates via email" }
      ]
    };
  },
  computed: {
    ...mapState("restaurant", ["pointOfContacts"]),
    ...mapState("auth", ["user"]),
    isAnyContactOpened() {
      return this.contacts.some((contact) => contact.isOpened);
    },
    isFormValid() {
      return this.valid && this.isPhoneValid && this.isContactInfoValid;
    }
  },
  async mounted() {
    this.loading = true;
    try {
      await this.getPointOfContact();
    } catch (e) {
      console.log("Error fetching POCs", e);
    } finally {
      this.loading = false;
      this.initContacts();
    }
  },

  methods: {
    ...mapActions("restaurant", [
      "getPointOfContact",
      "createPointOfContact",
      "updatePointOfContact"
    ]),
    initContacts() {
      if (this.pointOfContacts && this.pointOfContacts.length) {
        this.contacts = this.pointOfContacts.map((el) => {
          return { ...el, isOpened: false };
        });
      } else {
        this.contacts.push({
          name: this.user.name,
          phone: {
            country_code: this.user?.phone?.country_code,
            number: this.user?.phone?.number
          },
          updates_shared_via: this.contactTypes[0].value,
          updates_shared_to: {
            country_code: this.user?.phone?.country_code,
            number: this.user?.phone?.number
          },
          isOpened: true
        });
      }
      this.$nextTick(() => {
        this.valid = this.$refs.form?.validate();
      });
    },
    addContact() {
      this.contacts.forEach((obj) => {
        obj.isOpened = false;
      });
      this.contacts.push({
        name: "",
        phone: {
          country_code: "+91",
          number: ""
        },
        updates_shared_via: this.contactTypes[0].value,
        updates_shared_to: {
          country_code: "+91",
          number: ""
        },
        isOpened: true
      });
    },
    toggleCollapse(i) {
      this.contacts = this.contacts.map((obj, index) => ({
        ...obj,
        isOpened: index === i
      }));
    },
    deleteContact(index) {
      this.contacts.splice(index, 1);
    },
    async saveContacts(index) {
      this.saveLoading = true;
      const contact = this.contacts[index];
      let payload = {
        name: contact.name,
        phone: contact.phone,
        updates_shared_via: contact.updates_shared_via,
        updates_shared_to: contact.updates_shared_to
      };

      try {
        if (contact.id) {
          payload.id = contact.id;
          await this.updatePointOfContact({
            payload: { point_of_contacts: [payload] }
          });
        } else {
          await this.createPointOfContact({
            payload: { point_of_contacts: [payload] }
          });
        }
        this.initContacts();
      } catch (err) {
        this.$nuxt.$emit("show-error-toast", err);
      }
      this.saveLoading = false;
      // this.$emit("close-dialog");
    },
    discardContacts(index) {
      if (this.contacts[index].id) {
        this.contacts[index] = this.pointOfContacts[index];
        this.contacts[index].isOpened = false;
        this.contacts = JSON.parse(JSON.stringify(this.contacts));
      } else {
        this.contacts.splice(index, 1);
      }
      // this.$emit("close-dialog");
    },
    handleSelection(id) {
      const index = this.selection.indexOf(id);
      if (index >= 0) {
        this.selection.splice(index, 1);
      } else {
        this.selection.push(id);
      }
    },
    handleSubmit() {
      this.$emit("submit", this.selection);
    }
  }
};
